
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 511.999 511.999"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M467.069 212.578L267.381 12.861c-11.777-11.748-30.828-11.609-42.451-.015-11.689 11.719-11.689 30.747 0 42.451L424.647 255c11.7 11.7 30.721 11.7 42.422 0 11.732-11.732 11.732-30.692 0-42.422zM210.115 82.905l-1.503 7.534c-10.587 52.958-36.317 103.269-71.118 144.046l108.647 108.647c40.772-34.794 90.39-61.215 143.35-71.815l7.548-1.503L210.115 82.905zM117.575 256.989l-74.253 74.238c-17.545 17.545-17.618 46.029 0 63.647l42.422 42.422c17.545 17.545 46.029 17.617 63.647 0l74.246-74.246-106.062-106.061zm10.606 116.675c-5.859 5.859-15.352 5.859-21.211 0-5.859-5.859-5.859-15.352 0-21.211l21.211-21.211c5.859-5.859 15.352-5.859 21.211 0 5.859 5.859 5.859 15.352 0 21.211l-21.211 21.211zM286.266 445.278l20.405-20.405c17.619-17.616 17.561-46.1.001-63.631l-15.156-15.167c-8.377 5.627-16.377 11.741-24.155 18.265l18.1 18.127c5.845 5.815 5.886 15.279 0 21.196l-20.742 20.742-30.482-29.533-42.424 42.424 68.057 65.947c11.614 11.644 30.683 11.71 42.407-.015 11.704-11.704 11.704-30.732 0-42.437l-16.011-15.513zM346.864 0c-8.291 0-15 6.709-15 15v30c0 8.291 6.709 15 15 15s15-6.709 15-15V15c0-8.291-6.709-15-15-15zM466.864 120h-30c-8.291 0-15 6.709-15 15s6.709 15 15 15h30c8.291 0 15-6.709 15-15s-6.709-15-15-15zM447.469 34.394c-5.859-5.859-15.352-5.859-21.211 0l-30 30c-5.859 5.859-5.859 15.352 0 21.211s15.352 5.86 21.211 0l30-30c5.859-5.859 5.859-15.352 0-21.211z"}})])
          )
        }
      }
    